import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  CanLoad,
  CanActivate,
  Route,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { RolesService } from '../../services/roles/roles.service';
import { SharedStorageService } from 'ngx-store';
import { OAuthService } from 'angular-oauth2-oidc';
import { Utils } from '../../../shared/utils/utils';

@Injectable()
export class PaydAuthGuard implements CanActivateChild, CanLoad, CanActivate {
  constructor(
    protected router: Router,
    private rolesService: RolesService,
    private sharedStorageService: SharedStorageService,
    private oauthService: OAuthService,
    private utils: Utils
  ) {}

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      this.oauthService.loadDiscoveryDocumentAndTryLogin().then((isLoggedIn) => {
        if (isLoggedIn) {
          if (this.rolesService.isUserInternal() || this.rolesService.isUserClient()) {
            resolve(true);
          } else {
            this.router.navigate(['/access-denied']);
            resolve(false);
          }
        }
      });
      if (this.rolesService.isUserInternal() || this.rolesService.isUserClient()) {
        if (this.sharedStorageService.get('clientId') === null) {
          let storedUserInfo = this.sharedStorageService.get('userInfo');
          if (storedUserInfo == null) {
            storedUserInfo = this.utils.getUserInfo();
            const userInfoElement = storedUserInfo['clientId'];
            this.sharedStorageService.set('userInfo', storedUserInfo);
            this.sharedStorageService.set('clientId', userInfoElement);
            resolve(true);
          } else {
            const userInfoElement = storedUserInfo['clientId'];
            this.sharedStorageService.set('clientId', userInfoElement);
            resolve(true);
          }
        } else {
          resolve(true);
        }
      } else {
        this.router.navigate(['/access-denied']);
        resolve(false);
      }
    });
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isAccessAllowed(childRoute, state);
  }

  canLoad(route: Route, segments: UrlSegment[]) {
    return this.hasValidToken();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.hasValidToken();
  }

  private hasValidToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
